var _path, _path2, _path3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8TimorLeste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M44,24c0-11.046-8.954-20-20-20c-5.818,0-11.04,2.5-14.695,6.466L33.667,24L9.305,37.534 C12.96,41.5,18.182,44,24,44C35.046,44,44,35.046,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M9.305,10.466c-0.22,0.239-0.447,0.472-0.656,0.721L25.733,24L8.65,36.813 c0.208,0.25,0.435,0.482,0.656,0.721L33.667,24L9.305,10.466z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M8.65,11.187C5.749,14.658,4,19.123,4,24c0,4.877,1.749,9.342,4.65,12.813L25.733,24L8.65,11.187z M10.641,29.18l-0.57-3.773l-3.762-0.625l3.41-1.707l-0.566-3.77l2.676,2.719l3.41-1.707l-1.754,3.383l2.676,2.719l-3.762-0.625 L10.641,29.18z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "13.484,23.699 15.238,20.316 11.828,22.023 9.152,19.305 9.719,23.074 6.309,24.781 10.07,25.406 10.641,29.18 12.398,25.793 16.16,26.418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8TimorLeste);
export default __webpack_public_path__ + "static/media/icons8-timor-leste.f7ed0f65b6f4b9b0934046e944ad6442.svg";
export { ForwardRef as ReactComponent };